import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '@app/core/config/config.service';
import { AuthService } from '@app/core/guards/auth.service';
import { HttpService } from '@app/core/http/http.service';
import { TablePreferencesModel } from '../models/preferences/table-preferences.model';


@Injectable({
  providedIn: 'root'
})
export class PreferenceService extends HttpService {

  constructor(protected http: HttpClient, protected config: ConfigService, protected authService: AuthService) {
    super(http, config, authService, 'preferences');
  }

  saveTablePreferences(tablePreferences: TablePreferencesModel): Observable<any> {
    return this.invokePost(tablePreferences, "");
  }
}
